/**
 * @generated SignedSource<<ce289ab7929998d4b6b7fe005b15c70e>>
 * @relayHash 1892db8bde2fcd0b7e4b90287e429eb1
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 714123581c6713fe48973e14924da026b82609e0fee221990137782988ca4029

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { HorizontalNavQueueInnerQuery } from './HorizontalNavQueueInnerQuery.graphql';

const node: PreloadableConcreteRequest<HorizontalNavQueueInnerQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "714123581c6713fe48973e14924da026b82609e0fee221990137782988ca4029",
    "metadata": {},
    "name": "HorizontalNavQueueInnerQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
